module.exports = __webpack_public_path__ + "img/top_row.1a0e56.png";